// Committed snapshot used when the live Foreplay ad fetch fails (no auth,
// network, or the brand ids below have gone stale). Names follow the
// conventions the comparison report groups by (Agency_, ExternalCreator_,
// InHouse_). Stems must not double-prefix; ExternalCreator names must not
// include the substring "agency".

const FALLBACK_IMAGE = 'https://publicassets.foreplay.co/ad_og_bg.jpg'
const FALLBACK_IMAGE_LENS = 'https://publicassets.foreplay.co/lens_og_bg.jpg'
const FALLBACK_IMAGE_BOARD = 'https://publicassets.foreplay.co/board_og_bg.jpg'

const LENS_DEMO_FALLBACK_ADS = [
  {
    id: 'demo-ad-agency-01',
    name: 'Agency_Testimonial_Founder_01',
    thumbnail: FALLBACK_IMAGE,
    image: FALLBACK_IMAGE,
    live: true
  },
  {
    id: 'demo-ad-agency-02',
    name: 'Agency_Unboxing_Review_02',
    thumbnail: FALLBACK_IMAGE_LENS,
    image: FALLBACK_IMAGE_LENS,
    live: true
  },
  {
    id: 'demo-ad-agency-03',
    name: 'Agency_DayInTheLife_03',
    thumbnail: FALLBACK_IMAGE_BOARD,
    image: FALLBACK_IMAGE_BOARD,
    live: true
  },
  {
    id: 'demo-ad-creator-01',
    name: 'ExternalCreator_UGC_Hook_01',
    thumbnail: FALLBACK_IMAGE,
    image: FALLBACK_IMAGE,
    live: true
  },
  {
    id: 'demo-ad-creator-02',
    name: 'ExternalCreator_Review_Cut_02',
    thumbnail: FALLBACK_IMAGE_LENS,
    image: FALLBACK_IMAGE_LENS,
    live: true
  },
  {
    id: 'demo-ad-creator-03',
    name: 'ExternalCreator_Lifestyle_03',
    thumbnail: FALLBACK_IMAGE_BOARD,
    image: FALLBACK_IMAGE_BOARD,
    live: true
  },
  {
    id: 'demo-ad-inhouse-01',
    name: 'InHouse_Benefit_Grid_01',
    thumbnail: FALLBACK_IMAGE_BOARD,
    image: FALLBACK_IMAGE_BOARD,
    live: true
  },
  {
    id: 'demo-ad-inhouse-02',
    name: 'InHouse_Problem_02',
    thumbnail: FALLBACK_IMAGE,
    image: FALLBACK_IMAGE,
    live: true
  },
  {
    id: 'demo-ad-inhouse-03',
    name: 'InHouse_PatternInterrupt_03',
    thumbnail: FALLBACK_IMAGE_LENS,
    image: FALLBACK_IMAGE_LENS,
    live: true
  }
]

export default LENS_DEMO_FALLBACK_ADS
